// src/AdminRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

function AdminRoute() {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    // 1. ยังไม่ Login เด้งไปหน้า Login
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'admin') {
    // 2. Login แล้ว แต่ไม่ใช่ Admin เด้งกลับหน้าหลัก
    //alert("คุณไม่มีสิทธิ์เข้าถึงหน้านี้ (เฉพาะ Admin เท่านั้น)");
    return <Navigate to="/" replace />;
  }

  // 3. Login แล้ว และเป็น Admin
  return <Outlet />;
}

export default AdminRoute;